import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ConsentRequestsService } from '../consent-requests.service';
import { FormControl, Validators } from '@angular/forms';
import { debounceTime, Subscription } from 'rxjs';
import { PersonSearchService } from './person-search.service';
import { Person } from '../../../interfaces/person';

@Component({
    selector: 'person-search',
    templateUrl: './person-search.component.html',
    styleUrls: ['./person-search.component.scss'],
    providers: [PersonSearchService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonSearchComponent {
  @Input() roleName = '';
  @Input() roleColumn = '';
  @Input() required = false;
  @Input() person: Person | null = null;

  public groupId: string | null = null;
  @Input() control: FormControl<Person | string | null> = new FormControl<
    Person | string | null
  >('');
  private searchSub: Subscription;
  public columnsSub: Subscription;

  @Output() personChange = new EventEmitter<Person | null>();
  constructor(
    public consentRequestsService: ConsentRequestsService,
    public personSearch: PersonSearchService
  ) {}

  displayFn(person: Person) {
    return person && person.name ? person.name : '';
  }
  ngOnInit() {
    this.columnsSub = this.consentRequestsService.roleGroupColumns$.subscribe(
      (columns) => {
        if (columns.length) {
          let column = columns.find(
            (value) => value.role_column_name === this.roleColumn
          );
          if (column) {
            this.groupId = column.group_id;
          }
        }
      }
    );

    if (this.required) {
      this.control.addValidators(Validators.required);
    }
    this.searchSub = this.control.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value) => {
        if (typeof value === 'string' && value.length) {
          this.personSearch.searchForPerson(value, this.groupId);
        } else if (typeof value === 'string' && value.length === 0) {
          this.person = null;
          this.personSearch.clearPeople();
          this.personChange.emit(this.person);
        } else if (typeof value !== 'string') {
          this.person = value;
          this.personChange.emit(this.person);
        }
      });
  }

  ngOnDestroy() {
    this.searchSub?.unsubscribe();
    this.columnsSub?.unsubscribe();
  }
}
